import { AxiosError } from 'axios';
import { Modal } from 'react-bootstrap';
import api from '../../../services/cle';
import { useEffect, useState } from 'react';
import Spinner from '../../../rxlib/components/spinner';
import { SubmitHandler, useForm } from 'react-hook-form';
import { ApiError, FormExclusao } from '../../../services/tipos';
import { Exclusao } from '../../../rxlib/components/layout/exclusao';

interface UnidadeNegocioExclusaoProps {
    show: boolean;
    onHide: () => void;
    idUnidadeNegocio: string;
    onExcluir: (valor: boolean) => void;
    tratarErro: (error: AxiosError<ApiError>, mensagem: string) => void;
}

function UnidadeNegocioExclusao(props: UnidadeNegocioExclusaoProps) {
    const [nome, setNome] = useState<string>('');
    const [carregando, setCarregando] = useState<boolean>(false);
    const [carregandoUnidadeNegocio, setCarregandoUnidadeNegocio] = useState<boolean>(false);

    const { handleSubmit } = useForm<FormExclusao>();

    useEffect(() => {
        if (props.show) {
            setCarregandoUnidadeNegocio(true);
            api.get(`/UnidadeNegocio/${props.idUnidadeNegocio}`)
                .then(response => {
                    setNome(response.data.nome);
                    setCarregandoUnidadeNegocio(false);
                }).catch((error: AxiosError<ApiError>) => {
                    setCarregandoUnidadeNegocio(false);
                    props.tratarErro(error, 'Não foi possível realizar a consulta: ');
                });
        }
    }, [props]);

    const onSubmit: SubmitHandler<FormExclusao> = data => {
        setCarregando(true);
        api.delete(`/UnidadeNegocio/${props.idUnidadeNegocio}`, data)
            .then(response => {
                informarSucesso();
            }).catch((error: AxiosError<ApiError>) => {
                setCarregando(false);
                props.tratarErro(error, 'Não foi possível excluir a unidade de negocio: ');
            });
    }

    function informarSucesso() {
        props.onHide();
        props.onExcluir(true);
        setCarregando(false);
    }

    return (
        <Modal show={props.show} onHide={props.onHide} dialogClassName='rxlib-modal-exclusao' centered>
            <Modal.Body className='rxlib-modal-exclusao-body'>
                {
                    carregandoUnidadeNegocio
                        ? <Spinner
                            classStyle='rxlib-spinner' />
                        : <Exclusao
                            carregando={carregando}
                            onCancelar={props.onHide}
                            onSubmit={handleSubmit(onSubmit)}
                            titulo={`Deseja realmente excluir a unidade de negocio ${nome}?`} />
                }
            </Modal.Body>
        </Modal>
    );
}

export default UnidadeNegocioExclusao;